// extracted by mini-css-extract-plugin
module.exports = {"root":"PaymentsMobile_root__ADyqE","item":"PaymentsMobile_item__22kvN","label":"PaymentsMobile_label__1gJhR","amount":"PaymentsMobile_amount__24Am7"};